import { render, staticRenderFns } from "./WpBoard.vue?vue&type=template&id=e29d2afe&"
import script from "./WpBoard.vue?vue&type=script&lang=js&"
export * from "./WpBoard.vue?vue&type=script&lang=js&"
import style0 from "./WpBoard.vue?vue&type=style&index=0&id=e29d2afe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports